import { PersonContractType } from '@AppConstants';
import { FilterButtonItem } from '../FilterButton/FilterButton';

export const contractFilterOptions: FilterButtonItem[] = [
    { value: '', label: 'All' },
    { value: PersonContractType.Fix, label: '100%' },
    { value: PersonContractType.Tzv, label: 'TZV' },
    { value: PersonContractType.Freelance, label: PersonContractType.Freelance }
];